// Batch 34 · fork J: S13 — the W9 conclusion note (the conclusion itself is one of two choices); S16 — the cut-off
// post-year-end answer "This year - below clearly trivial (not accumulated)" and W9's clearly-trivial note listing those rows.
// EN + AR, merged into lib/i18n.js translations (big-file rule: new strings in their own file).
export const I18N_B34J = {
  en: {
    b34j: {
      pyeTrivial: "This year - below clearly trivial (not accumulated)",
      conclusionNote: "Conclusion note",
      conclusionNoteHint: "The explanation of the conclusion (the conclusion itself is one of the two choices).",
      trivialTitle: "Below clearly trivial — not accumulated",
      trivialNote: "Cut-off rows that belong to this year but are below clearly trivial ({ct}). Listed here; not in the totals above.",
      trivialTotal: "Total of {n} row(s): {v}",
      colWs: "Worksheet", colDate: "Date", colRef: "Voucher", colDesc: "Description", colAmount: "Amount", colRemark: "Remark",
      atOrAboveCt: "At or above clearly trivial now — review the answer",
    },
  },
  ar: {
    b34j: {
      pyeTrivial: "هذه السنة - أقل من الحد غير المؤثر بوضوح (لا يُجمَّع)",
      conclusionNote: "ملاحظة الاستنتاج",
      conclusionNoteHint: "شرح الاستنتاج (الاستنتاج نفسه أحد الخيارين).",
      trivialTitle: "أقل من الحد غير المؤثر بوضوح — لا يُجمَّع",
      trivialNote: "صفوف اختبار القطع التي تخص هذه السنة لكنها أقل من الحد غير المؤثر بوضوح ({ct}). تُعرض هنا ولا تدخل في المجاميع أعلاه.",
      trivialTotal: "مجموع {n} صف: {v}",
      colWs: "ورقة العمل", colDate: "التاريخ", colRef: "رقم القيد", colDesc: "الوصف", colAmount: "المبلغ", colRemark: "ملاحظة",
      atOrAboveCt: "يساوي الآن الحد غير المؤثر بوضوح أو يزيد عليه — راجع الإجابة",
    },
  },
};

export default I18N_B34J;
